// Loads the Ishara widget on desk and website pages (the LMS SPA gets it from custom-build.js).
// The widget derives its API host from its own <script src> and auto-initializes from
// data-ishara-org-id, so it must be injected as a tag rather than bundled or initialized here.
import config from "../../widget_config.json";

(function () {
	if (window.isharaWidgetInstance || document.querySelector("script[data-ishara-org-id]")) {
		return;
	}

	const script = document.createElement("script");
	script.src = config.script_url;
	script.async = true;
	script.setAttribute("data-ishara-org-id", config.organization_id);
	document.head.appendChild(script);
})();
